<template>
  <component :is="currentComponent" />
</template>

<script>
export default {
  name: 'Placeholder',
  data() {
    return {
      currentComponent: null
    }
  },
  created() {
    this.loadComponent()
  },
  watch: {
    // 监听路由变化，重新加载组件
    '$route': 'loadComponent'
  },
  methods: {
    async loadComponent() {
      try {
        // 从路由路径获取组件路径，移除开头的斜杠并转换为小写
        const componentPath = this.$route.path.replace(/^\//, '')
        
        try {
        const componentPathLowerCase = this.$route.path.replace(/^\//, '').toLowerCase()
          // 尝试加载组件
          const component = await import(`@/views/${componentPathLowerCase}.vue`)
          this.currentComponent = component.default
        } catch (e) {
          // 如果小写路径加载失败，尝试首字母大写的方式
          const capitalizedPath = componentPath.split('/').map(part => 
            part.charAt(0).toUpperCase() + part.slice(1)
          ).join('/')
          const component = await import(`@/views/${capitalizedPath}.vue`)
          this.currentComponent = component.default
        }
      } catch (error) {
        console.error('加载组件失败:', error)
        this.$message.error(`页面加载失败: ${this.$route.path}，请检查组件文件是否存在`)
      }
    }
  }
}
</script> 